function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "calendar_today (2)");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Telas-Incendio-Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Emiss\\xE3o-Full-Page",
  transform: "translate(-333.000000, -1326.000000)",
  fill: "#FF6F0B",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "calendar_today-(2)",
  transform: "translate(333.000000, 1326.000000)"
}, React.createElement("path", {
  d: "M13.88411,15.4446809 L13.88411,5.42553191 L1.51857453,5.42553191 L1.51857453,15.4446809 L13.88411,15.4446809 Z M13.88411,1.55531915 C14.2938841,1.55531915 14.6494234,1.71205674 14.9507279,2.02553191 C15.2520323,2.33900709 15.4026846,2.70070922 15.4026846,3.1106383 L15.4026846,15.4446809 C15.4026846,15.8546099 15.2520323,16.2163121 14.9507279,16.5297872 C14.6494234,16.8432624 14.2938841,17 13.88411,17 L1.51857453,17 C1.10880045,17 0.753261178,16.8432624 0.451956707,16.5297872 C0.150652236,16.2163121 0,15.8546099 0,15.4446809 L0,3.1106383 C0,2.70070922 0.150652236,2.33900709 0.451956707,2.02553191 C0.753261178,1.71205674 1.10880045,1.55531915 1.51857453,1.55531915 L2.31401834,1.55531915 L2.31401834,0 L3.83259287,0 L3.83259287,1.55531915 L11.5700917,1.55531915 L11.5700917,0 L13.0886662,0 L13.0886662,1.55531915 L13.88411,1.55531915 Z",
  id: "Shape"
}))));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "16px",
    height: "17px",
    viewBox: "0 0 16 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.207a1ce6.svg";
export { ForwardRef as ReactComponent };